import { useState } from 'react';
import { Form, redirect, Link } from 'react-router-dom';
import Wrapper from '../assets/wrappers/RegisterAndLoginPage';
import {
  Logo,
  FormRow,
  TermsBox,
  SubmitBtn,
  AutoCompleteInput,
} from '../components';
import { customFetch } from '../utils/custom-fetch.js';
import { toast } from 'react-toastify';
import { CITIES } from '../../../utils/constants.js';

export const action = async ({ request }) => {
  const formData = await request.formData();
  const data = Object.fromEntries(formData);
  console.log(data);
  try {
    await customFetch.post('/auth/register', data);
    toast.success('הרישום בוצע בהצלחה');
    return redirect('/login');
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.msg);
    return error;
  }
};

const Register = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [city, setCity] = useState('');
  const [role, setRole] = useState('user'); 
  const [showCompanyDetails, setShowCompanyDetails] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleChange = (e) => {
    setCity(e.target.value); // Directly set the value to city
  };

  const handleRoleChange = (selectedRole) => {
    setRole(selectedRole);
    // אם מדובר בחברת אחזקה, נציג את השדות של החברה
    setShowCompanyDetails(selectedRole === 'maintenance');
  };

  return (
    <Wrapper>
      <Form method='post' className='form' aria-live='polite'>
        <Logo className='logo' />
        <h4 className='form-title'>רישום</h4>
        
        {/* שדה שם פרטי ושם משפחה */}
        <FormRow type='text' name='name' labelText='שם פרטי' required />
        <FormRow type='text' name='lastName' labelText='שם משפחה' required />

        {/* בחירת עיר */}
        <AutoCompleteInput
          options={CITIES}
          name='city'
          labelText='עיר'
          placeholder='אנא בחר עיר מגורים...'
          value={city}
          onChange={handleChange}
        />
        <input type='hidden' name='city' value={city} />

        {/* שדה אימייל וסיסמה */}
        <FormRow type='email' name='email' labelText='כתובת דואר אלקטרוני' required />
        <FormRow type='password' name='password' labelText='סיסמה חדשה' required />
        <FormRow type='password' name='passwordConfirm' labelText='אימות סיסמה' required />

        {/* סוג משתמש - בחירת role */}
        <div className='role-selection'>
          <h5>בחר סוג משתמש:</h5>
          <div className='role-cards'>
            <div className={`card ${role === 'user' ? 'selected' : ''}`} onClick={() => handleRoleChange('user')}>
              <h6>משתמש פרטי</h6>
              <p>מתאים למי שמעוניין להקים בניין אחד בלבד ולנהל אותו.</p>
            </div>
            <div className={`card ${role === 'maintenance' ? 'selected' : ''}`} onClick={() => handleRoleChange('maintenance')}>
              <h6>חברת אחזקה</h6>
              <p>מיועד לחברות ניהול המנהלות מספר בניינים.</p>
            </div>
            <div className={`card ${role === 'advertiser' ? 'selected' : ''}`} onClick={() => handleRoleChange('advertiser')}>
              <h6>מפרסם</h6>
              <p>מתאים לעסקים המעוניינים לפרסם במערכת.</p>
            </div>
          </div>
        </div>

        <input type='hidden' name='role' value={role} />

        {/* פרטים נוספים לחברת אחזקה */}
        {showCompanyDetails && (
          <>
            <FormRow type='text' name='companyName' labelText='שם החברה' required />
            <FormRow type='text' name='companyAddress' labelText='כתובת החברה' required />
          </>
        )}

        {/* תנאים */}
        <div className='terms-box'>
          <TermsBox />
        </div>

        {/* תיבת סימון - הסכמה לתנאים */}
        <div className='checkbox-wrapper'>
          <input
            type='checkbox'
            id='terms'
            name='terms'
            onChange={handleCheckboxChange}
          />
          <label style={{ margin: '10px' }} htmlFor='terms'>
            קראתי ואני מסכים לתנאים
          </label>
        </div>

        {/* כפתור שליחה */}
        <SubmitBtn buttonText='רישום' />

        {/* לינק לכניסה */}
        <p>
          כבר רשומים ? 
          <Link to='/login' className='member-btn'>
            כניסה
          </Link>
        </p>
      </Form>
    </Wrapper>
  );
};

export default Register;
